<script>
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwGridDual from '@/components/generic/tw-grid-dual.vue'
import { useDonationsStore } from '@/stores/donation.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwButton from '@/components/generic/tw-button.vue'

export default {
  name: 'DonationDetailsPage',
  components: { TwButton, TwLoadingSpinner, TwGridDual, TwCard, TwContainer },
  props: {
    donationId: {
      type: Number,
      required: true
    }
  },
  computed: {
    donation() {
      return useDonationsStore().getItemById(this.donationId)
    }
  },
  mounted() {
    useDonationsStore().fetchItemById(this.donationId)
  }
}
</script>

<template>
  <tw-container>
    <h1 class="my-4">
      Donation #{{ donationId }}
    </h1>
    <tw-card v-if="donation">
      <tw-grid-dual>
        <div>
          <div class="text-center font-bold mt-10 mb-5">
            Donor Summary
          </div>

          <div class="font-mulish flex flex-col gap-2">
            <div> {{ donation.billing_name }} </div>
            <div> {{ donation.billing_address }} </div>
            <div> {{ donation.billing_city }}, {{ donation.billing_state }} {{ donation.billing_zip }} </div>
            <div> {{ donation.billing_phone }} </div>
            <div> {{ donation.billing_email }} </div>
          </div>
        </div>
        <div>
          <div v-if="donation.cached" class="font-mulish">
            <div class="flex justify-between mb-3">
              <span class="text-gray-600 font-bold">Donation Total:</span>
              <span class="text-gray-900">{{ donation.cached.amount_formatted }}</span>
            </div>
            <div class="flex justify-between mb-3">
              <span class="text-gray-600 font-bold">Date:</span>
              <span class="text-gray-900"> {{ $filters.formatDate(donation.created_at) }} </span>
            </div>
            <div class="flex justify-between mb-3">
              <span class="text-gray-600 font-bold">Campaign:</span>
              <span class="text-gray-900"> {{ donation.cached.fundraiser_title }}</span>
            </div>
            <div v-if="donation.cached.beneficiary_user_name" class="flex justify-between mb-3">
              <span class="text-gray-600 font-bold">Allocation:</span>
              <span class="text-gray-900"> {{ donation.cached.beneficiary_user_name }}</span>
            </div>
            <div v-if="donation.billing_method" class="flex justify-between mb-3">
              <span class="text-gray-600 font-bold">Giving Method:</span>
              <span class="text-gray-900">{{ donation.billing_method }}</span>
            </div>
            <div v-if="donation.billing_transaction_id" class="flex justify-between">
              <span class="text-gray-600 font-bold">Transaction No.:</span>
              <span class="text-gray-900"> {{ donation.billing_transaction_id }}</span>
            </div>
          </div>
        </div>
      </tw-grid-dual>
      <div class="flex flex-row justify-center gap-2 mb-5 mt-10">
        <tw-button size="padded" disabled>
          Refund (not implemented)
        </tw-button>
        <tw-button size="padded" variant="danger" disabled>
          Delete (not implemented)
        </tw-button>
      </div>
    </tw-card>
    <tw-loading-spinner v-else />
  </tw-container>
</template>

<style scoped>

</style>
